module.exports = __webpack_public_path__ + "img/_DSC7816-min.83b2c251.jpg";